import api from "../api";

export function groupCourseModuleRequest() {
  return api.get(`/module_sets`);
}

export function groupCourseModuleListRequest(payload) {
  return api.get(`/module_sets/${payload}/module_documents`);
}
